<template>
  <div>
    <Head></Head>
    <Navbar />
    <Banner></Banner>
    <div class="container">
      <div
        class="content"
        v-if="this.newsId == 107"
      >
        <div class="title">2023安徽省全民健身广场舞大赛</div>
        <div class="img"><img src="../assets/dance.jpg" /></div>
        <p>
          10月15日，“养固健杯”2023安徽省全民健身广场舞大赛（合肥老城站）预赛在合肥城隍庙广场举行。来自合肥庐阳区、瑶海区、蜀山区、包河区、高新区等地各社区的20余支群众文体社团参赛队，用饱满的热情、鲜明的节奏、优美的舞姿，充分展示了奋发向上、乐观进取的精神风貌。年纪最大的参赛者已有71岁！
        </p>
        <p>
          本次广场舞大赛由安徽省社会体育指导中心、安徽省健康文化旅游产业促进会指导支持，安徽科学技术出版社是主办单位之一。安徽科学技术出版社乐龄听书同时举办了会员线下康养服务日活动，全面升级老年健康生活，推出的五项权益囊括老年生活全部内涵：有所学、有所为、有所养、有所医、有所选。
        </p>
        <p>
          恰逢重阳节将临，乐龄听书还精心组织了健康科普义诊、健康检测服务等公益活动：安徽医科大学第一附属医院的医护专家们带来了主题为“做好慢性病防控，树积极老龄观，促健康老龄化”的老年护理专题义诊；立方大药房推出了义诊、免费测血压血糖和购药优惠活动；三卿科技现场免费提供老年防摔服试穿及健康体检服务。
        </p>
      </div>

      <div
        class="content"
        v-else
      >
        <div class="title">乐龄听书开启第三届“聆听军功章里的故事”展播</div>
        <div class="img">
          <img
            src="../assets/award.jpg"
            style="width: 300px; height: 300px"
          />
        </div>
        <p>
          为纪念抗美援朝胜利70周年，致敬志愿军战士，安徽省退役军人事务厅主办、安徽科学技术出版社承办的第三届“聆听军功章里的故事”开启征集活动。经过一个半月的征集、筛选，现乐龄听书已将征集的故事择优录制成音频，进行专题展播。
        </p>
        <p>
          沿着时光之河，重启一段记忆。让我们聆听抗美援朝出国作战的亲历者、见证者，红色血脉的传承者讲述那段峥嵘岁月。
        </p>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from './index/Head';
import Navbar from './index/Navbar.vue';
import Banner from './index/Banner';
import Footer from './index/Footer';

export default {
  name: 'Contact',
  components: {
    Head,
    Navbar,
    Banner,
    Footer,
  },
  props: {
    newsId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.container {
  width: 100%;
  // height:1000px;
  background-color: white;
  overflow: hidden;
}

.content {
  width: 1200px;
  // height:1000px;
  // background-color: pink;
  margin: 0 auto;
  overflow: hidden;
  text-align: center;
  margin-bottom: 90px;

  .title {
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    // background-color: red;
    margin-top: 39px;
  }

  .img {
    margin-top: 28px;
    margin-bottom: 24px;
  }

  p {
    width: 1148px;
    text-align: left;
    font-size: 14px;
    line-height: 24px;
    // background-color: red;
    margin: 0 auto;
    text-indent: 26px;
  }
}
</style>
